// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__yixYI","inputWrap":"Table_inputWrap__cKlsE","col":"Table_col__2IWul","bmiTooltip":"Table_bmiTooltip__IhuxF"};